export function locationDots() {
  const patertDots = $(".location-section");
  const linkDots = patertDots.find(
    ".location-col li button, .location-col li a"
  );
  const allDonts = patertDots.find("[data-dot]");
  const classActive = "active";

  linkDots.hover(
    function () {
      const link = $(this);
      const attrDot = link.parent().data("dot");

      allDonts.removeClass(classActive);
      patertDots.find(`[data-dot='${attrDot}']`).addClass(classActive);
    },
    function () {
      allDonts.removeClass(classActive);
    }
  );
}



// WEBPACK FOOTER //
// ./assets/js/modules/locationDots.js